import React from "react";
import { Link } from 'react-router-dom';
import DealerConst from '../dealer-const';


const DealerInfoField = ({ dealer }) => <Link to={ `${ DealerConst.basePath }/${ dealer.id }` }> { dealer.company_name }</Link>

export default DealerInfoField;